import get from 'lodash/get'

function getFilteredContacts(contacts, types) {
  if (!Array.isArray(contacts) || !contacts.length || !types.length) {
    return [];
  }

  return contacts.filter((item) => types.indexOf(item.type.id) !== -1);
}

const getCityContacts = (city, types, storeContacts = []) => {
  const cityContacts = getFilteredContacts(get(city, 'contacts', []), types);

  if (cityContacts.length > 0) {
    return cityContacts
  }

  return getFilteredContacts(storeContacts, types);
}

const getFirstCityContact = (city, type) => {
  return get(getCityContacts(city, [type]), '0.value')
}

export {
  getFirstCityContact,
  getCityContacts,
}
